import { DoubleSide, MeshBasicMaterial } from 'three';

const acceptedImageTypes = [
    { type: 'image/svg+xml', label: 'SVG', extensions: '.svg' },
    { type: 'image/png', label: 'png', extensions: '.png' },
    { type: 'image/webp', label: 'webp', extensions: '.webp' },
    { type: 'image/jpeg', label: 'jpeg', extensions: '.jpeg,.jpg' },
];

const meshBasicMaterial = new MeshBasicMaterial({
    side: DoubleSide,
    depthTest: true, // Enable depth testing for proper layering
    depthWrite: false, // Disable depth writing to allow glass to render over it
});
const maxImageSize = 8_000_000; // 8Mo
// Upper bound for the BAT images (recto + verso) sent to POST /pdf.
// Must stay below the server body limits (nginx client_max_body_size / PHP post_max_size = 50M).
const maxBatUploadSize = 45_000_000; // 45Mo

const DEFAULT_CAMERA_ANIMATION_DURATION = 750;
const CANVAS_ZOOM_MIN_TOUCH = 0.125;
const CANVAS_ZOOM_MIN_DESKTOP = 0.25;
const CANVAS_ZOOM_MAX = 3;

const THROTTLE_TOUCH_TIMING = 8; // 8ms for touch (~120fps)
const THROTTLE_MOUSE_TIMING = 16; // 16ms for mouse (~60fps)

const BUTTON_GAP_MOBILE = 30; // Smaller gap on mobile
const BUTTON_GAP_DESKTOP = 50; // Default gap on desktop
const TRIGGER_AREA_MOBILE = 80; // Smaller trigger area on mobile
const TRIGGER_AREA_DESKTOP = 250; // Default trigger area on desktop

const MOBILE_BREAKPOINT = 768; // Define a breakpoint for mobile devices

export {
    acceptedImageTypes,
    BUTTON_GAP_DESKTOP,
    BUTTON_GAP_MOBILE,
    CANVAS_ZOOM_MAX,
    CANVAS_ZOOM_MIN_DESKTOP,
    CANVAS_ZOOM_MIN_TOUCH,
    DEFAULT_CAMERA_ANIMATION_DURATION,
    maxBatUploadSize,
    maxImageSize,
    meshBasicMaterial,
    MOBILE_BREAKPOINT,
    THROTTLE_MOUSE_TIMING,
    THROTTLE_TOUCH_TIMING,
    TRIGGER_AREA_DESKTOP,
    TRIGGER_AREA_MOBILE,
};
